import { ArrowLeft, ChevronLeft, ChevronRight, Maximize } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { useFullscreen } from '../useBoard';
import { useIdleHidden } from './useIdleHidden';

type BoardControlsProps = {
  backHref: string;
  previousHref?: string;
  nextHref?: string;
};

/** The only controls on the board, top left; they fade after a few quiet seconds and return on any movement or focus. */
export function BoardControls({ backHref, previousHref, nextHref }: BoardControlsProps) {
  const { hidden, show } = useIdleHidden();
  const { toggle } = useFullscreen();
  return (
    <nav
      aria-label="Bord"
      onFocus={show}
      className={`no-print fixed bottom-3 left-3 z-10 flex gap-2 transition-opacity duration-300 focus-within:pointer-events-auto focus-within:opacity-100 ${hidden ? 'pointer-events-none opacity-0' : 'opacity-100'}`}
    >
      <Button asChild variant="outline" className="min-h-11 bg-popover">
        <Link to={backHref}>
          <ArrowLeft /> Terug
        </Link>
      </Button>
      {previousHref && (
        <Button asChild variant="outline" size="icon" className="min-h-11 min-w-11 bg-popover">
          <Link to={previousHref} aria-label="Vorige dag">
            <ChevronLeft />
          </Link>
        </Button>
      )}
      {nextHref && (
        <Button asChild variant="outline" size="icon" className="min-h-11 min-w-11 bg-popover">
          <Link to={nextHref} aria-label="Volgende dag">
            <ChevronRight />
          </Link>
        </Button>
      )}
      <Button variant="outline" className="min-h-11 bg-popover" onClick={toggle}>
        <Maximize /> Volledig scherm
      </Button>
    </nav>
  );
}
